module.exports = __webpack_public_path__ + "img/s7on.3aa8e850.svg";